import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className='notfound page flex flex-col justify-center items-center space-y-5 h-screen w-screen bg-cents-grey'>
      <h1 className='text-2xl font-medium text-cents'>404 - Page Not Found</h1>
      <p>La pagina che cerchi non esiste.</p>
      <Link to="/login">
        <button className='flex justify-center items-center text-cents-white bg-cents-purple h-14 w-[240px] rounded-2xl font-medium text-base mt-10'>Torna al Login</button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
